export default __webpack_public_path__ + "static/IN-8015v6014_resTestBig4-a2819e270e2f6144b4229ad9bd8193f0.webp";